import styled, { createGlobalStyle } from 'styled-components';
import Media from '../Theme/media-breackpoint';

interface GlobalStylesType {
    GlobalStyle: ReturnType<typeof createGlobalStyle>;
    MainSection: ReturnType<typeof styled.div>;
    Container: ReturnType<typeof styled.div>;
    W25: ReturnType<typeof styled.div>;
    W25V2: ReturnType<typeof styled.div>;
    W20: ReturnType<typeof styled.div>;
    W80: ReturnType<typeof styled.div>;
    W200px: ReturnType<typeof styled.div>;
    W275px: ReturnType<typeof styled.div>;
    W605px: ReturnType<typeof styled.div>;
    W880px: ReturnType<typeof styled.div>;
    TenpxGutter: ReturnType<typeof styled.div>;
}

const Gs: GlobalStylesType = {} as GlobalStylesType;

Gs.GlobalStyle = createGlobalStyle`
  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300;400;500;600;700;800;900&display=swap');
  
  :root {
    --gradient-primary: linear-gradient(135deg, hsl(var(--neon)), hsl(var(--teal)));
    --gradient-secondary: linear-gradient(180deg, hsl(var(--navy)), hsl(210 59% 8%));
    --gradient-accent: linear-gradient(90deg, hsl(var(--teal)), hsl(var(--neon)));
    --shadow-elegant: 0 10px 30px -10px hsl(var(--neon) / .2);
    --shadow-glow: 0 0 40px hsl(var(--neon) / .3);
    --shadow-card: 0 4px 20px hsl(210 59% 5% / .4);
    --transition-smooth: all .3s cubic-bezier(.4, 0, .2, 1);
  }

  html { 
    background: #FFF;
  }
  
  body {  
    margin: 0; 
    padding: 0;  
    font: 400 16px/20px Inter, sans-serif;  
    background: #FFF; 
    color: #000; 
  }
  
  .myTip{ 
    max-width: 300px; 
    font: 400 14px/22px 'Inter', arial !important; 
    color: #6A727C !important;
  } 
  
  input{ 
    outline: none;
    border-radius: 12px !important;
  }
  
  img{ 
    max-width: 150%; 
    height: auto; 
  }
  
  button{  
    background: transparent; 
    outline: none; 
    border: 0;
  }
  
  .verification-status-btn {
    border-radius: 12px !important;
    -webkit-border-radius: 12px !important;
    -moz-border-radius: 12px !important;
  }
  
  .collapse-css-transition { 
    transition: all 280ms cubic-bezier(0.4, 0, 0.2, 1); 
  }
  
  .app__collapse{ 
    visibility: hidden; 
    opacity: 0; 
    height: 0px; 
  }
  
  .app__collapse.collapse-active{ 
    visibility: visible; 
    opacity: 1; 
    height: auto; 
  }
  
  .mb-0{ 
    margin-bottom: 0 !important;
  }

  .track-vertical{ 
    width: 19px !important; 
    height: 100%; 
    display: block; 
    position: absolute; 
    right: -5px;
  }
  
  .thumb-vertical{ 
    width: 6px !important; 
    border-radius: 30px; 
    margin: 5px; 
    background-color: #ccc; 
  }
  
  .thumb-horizontal {
    background-color: #ccc;
    height: 6px !important;
    border-radius: 30px;
    bottom: -10px;
  }
  
  .track-horizontal {
    width: 100%;
    left: 0px;
    bottom: 0px;
    height: 19px !important;
  }
  
  .react-autosuggest__suggestions-container{ 
    background-color: #6A727C; 
    border-radius: 10px; 
    position: absolute; 
    z-index: 99; 
    width: 100%; 
    top: 55px; 
    left: 0px; 
    list-style-type: none;
  }
  
  .react-autosuggest__suggestions-container--open{
    box-shadow: 0px 2px 5px 1px #ccc;
  }
  
  .react-autosuggest__suggestions-list{ 
    list-style-type: none; 
    padding: 0px 15px;
  }
  
  .react-autosuggest__suggestion{
    margin-bottom: 5px; 
    padding: 5px 10px; 
    cursor: pointer; 
    border-radius: 5px;
  }
  
  .react-autosuggest__suggestion--highlighted{
    background-color: #eef2f7;
  }
  
  .IScroll{
    overflow-x: hidden !important;
  }
`;

Gs.MainSection = styled.div`
    margin: 60px auto 0 auto;
    padding: 0 2rem;
    background: #fff !important;
    width: 100%;
    ${Media.md} {
        margin: 80px auto 0 auto;
    }
    ${Media.sm} {
        margin: 80px auto 0 auto;
        padding: 0 1rem;
    }
`;

Gs.Container = styled.div`
    margin: 70px auto;
    width: 100%;
    max-width: 1400px;
    background: #fff;
    ${Media.lg} {
        max-width: 88%;
    }
    ${Media.md} {
        max-width: 94%;
    }
`;

Gs.W25 = styled.div`
    width: 25%;
`;

Gs.W25V2 = styled.div`
    width: 25%;
    margin-bottom: 20px;
    ${Media.md} {
        width: 33.33%;
    }
    ${Media.sm} {
        width: 50%;
    }
    ${Media.xs} {
        width: 295px;
        margin: 0px auto 20px;
    }
`;

Gs.W20 = styled.div`
    width: 20%;
    ${Media.md} {
        width: 25%;
    }
    ${Media.sm} {
        width: 50%;
    }
    ${Media.xs} {
        width: 295px;
        margin: 0px auto;
    }
`;

Gs.W80 = styled.div`
    width: 80%;
    ${Media.sm} {
        width: 100%;
    }
`;

Gs.W200px = styled.div`
    width: 100%;
    max-width: 200px;
    ${Media.md} {
        display: none;
    }
`;

Gs.W275px = styled.div`
    width: 100%;
    max-width: 275px;
    ${Media.lg} {
        max-width: 250px;
    }
    ${Media.md} {
        max-width: 35%;
    }
    ${Media.sm} {
        display: none;
    }
`;

Gs.W605px = styled.div`
    width: 100%;
    max-width: 605px;
    ${Media.lg} {
        max-width: 450px;
    }
    ${Media.md} {
        max-width: 65%;
    }
    ${Media.sm} {
        max-width: 100%;
    }
`;

Gs.W880px = styled.div`
    width: 100%;
    max-width: 880px;
    ${Media.lg} {
        max-width: 700px;
    }
    ${Media.md} {
        max-width: 100%;
    }
`;

Gs.TenpxGutter = styled.div`
    margin: 0px 10px;
`;

export default Gs;
